<div class="layout-container">
    <div class="table-container" *ngIf="offers.length || !(filters | hasEmptyValues)">
        <div class="table-header">
            <form name="filters" class="row">
                <div class="small-4">
                    <app-form-search name="search" placeholder="{{ 'shared.filter.keyword' | translate }}"
                        (termChange)="onTermChange($event)" [term]='filters.term'>
                    </app-form-search>
                </div>
                <div class="small-2">
                    <app-form-datepicker name="from" placeholder="{{ 'shared.filter.date-from' | translate }}"
                        [(ngModel)]="filters.start_date" [max]="filters.end_date"
                        (dateChange)="onStartDateChange($event)">
                    </app-form-datepicker>
                </div>
                <div class="small-2">
                    <app-form-datepicker name="to" placeholder="{{ 'shared.filter.date-to' | translate }}"
                        [(ngModel)]="filters.end_date" [min]="filters.start_date"
                        (dateChange)="onEndDateChange($event)">
                    </app-form-datepicker>
                </div>
                <div class="small-2"></div>
                <div class="small-2">
                    <!-- <a href="" class="button button-primary">{{ 'shared.button.export' | translate }}</a> -->
                </div>
            </form>
        </div>

        <div class="table-scrollable">
            <table class="scope-table table table-stripped table-bordered">
                <colgroup>
                    <col style="width:140px">
                    <col />
                    <col style="width:140px">
                    <col *ngIf="hasSegments">
                    <col style="width:100px">
                    <col style="width:135px">
                    <col style="width:120px">
                    <col style="width:185px">
                    <col style="width:140px">
                    <col style="width:100px">
                    <col style="width:110px">
                    <col style="width:100px">
                </colgroup>

                <!-- Head -->
                <thead>
                    <tr>
                        <th colspan="2" class="table-orderable" (click)="onOrderBy('brand__name')"
                            [ngClass]="getOrderingClass('brand__name')">
                            {{ 'shared.table.brand' | translate }}
                        </th>
                        <th>
                            {{ 'shared.table.parameters' | translate }}
                        </th>
                        <th *ngIf="hasSegments">
                            {{ 'shared.table.segments' | translate }}
                        </th>
                        <th class="table-orderable" (click)="onOrderBy('highlight_level')"
                            [ngClass]="getOrderingClass('highlight_level')">
                            {{ 'shared.table.highlight' | translate }}
                        </th>
                        <th class="table-orderable" (click)="onOrderBy('type')" [ngClass]="getOrderingClass('type')">
                            {{ 'shared.table.type' | translate }}
                        </th>
                        <th class="table-orderable centered" (click)="onOrderBy('cashback_rate')"
                            [ngClass]="getOrderingClass('cashback_rate')">
                            {{ 'shared.table.reward' | translate }}
                        </th>
                        <th class="table-orderable" (click)="onOrderBy('start_date')"
                            [ngClass]="getOrderingClass('start_date')">
                            {{ 'shared.table.dates' | translate }}
                        </th>
                        <th>
                            {{ 'shared.table.real-end-date' | translate }}
                        </th>
                        <th>
                            {{ 'shared.table.completion' | translate }}
                        </th>
                        <th>
                            {{ 'shared.table.status' | translate }}
                        </th>
                        <th class="right">
                            {{ "shared.table.actions" | translate }}
                        </th>
                    </tr>
                </thead>
                <!-- Body -->
                <tbody>
                    <tr *ngFor="let offer of offers | paginate: paginationSettings"
                        [ngClass]="{ 'scope-no-active-phase': isHighlighted(offer) }">
                        <td colspan="2" class="elipsis" [title]="offer.brand?.name">
                            <strong>{{ offer.brand?.name || '...' }}</strong>
                            <br>
                            <small>{{ offer.reference }}</small>
                        </td>
                        <td>
                            <app-offer-icons [item]="offer"></app-offer-icons>
                        </td>
                        <td *ngIf="hasSegments" class="elipsis">
                            <app-expandable-list [list]="offer.segments" key="name" placeholder="-"
                                limit="1"></app-expandable-list>
                        </td>
                        <td>
                            <a class="link-action" (click)="onOpenOfferQuickeditor(offer)"
                                *ngIf="offer.highlight_level && !isNotEditable(offer)">
                                {{ 'shared.status.' + offer.highlight_level | translate }}
                            </a>

                            <span *ngIf="offer.highlight_level && isNotEditable(offer)">
                                {{ 'shared.status.' + offer.highlight_level | translate }}
                            </span>
                        </td>
                        <td>
                            {{ 'offers.shared.types.' + offer.type | translate }}
                        </td>
                        <td class="scope-reward-column elipsis centered" *ngIf="tab !== 'ENDED'">
                            <div *ngIf="![ 'ENDED', 'DEACTIVATED' ].includes(offer.status)"></div>

                            <div *ngIf="offer.type === 'CASHBACK'">
                                {{ isOfferEnded(offer) ? '-' : (offer.cashback_rate | localizedNumber) + '%' }}

                                <app-tooltip *ngIf="isHighlighted(offer)" [message]="'offers.list.is-no-phase'"
                                    position="left">
                                    <i class="i i-status-cancel"></i>
                                </app-tooltip>
                            </div>
                            <div *ngIf="offer.type === 'LBS_CASHBACK'">
                                {{ isOfferEnded(offer) ? '-' : (offer.cashback_rate | localizedNumber) + '%' }}
                            </div>
                            <div *ngIf="offer.type === 'GENERIC_COUPON'" [title]="offer.coupon_generic_code">
                                {{ offer.coupon_generic_code }}
                            </div>
                            <div *ngIf="offer.type === 'UNIQUE_COUPON'" [title]="offer.coupon_file?.name">
                                {{ offer.coupon_file?.name || '…' }}
                            </div>
                            <div *ngIf="offer.type === 'AFFILIATION'">
                                <div *ngIf="offer.max_reward_rate">
                                    {{ offer.max_reward_rate | localizedNumber : '1.2-2' }}%
                                </div>
                                <div *ngIf="offer.max_fixed_reward_amount">
                                    {{ offer.max_fixed_reward_amount | localizedNumber : '1.2-2' }}€
                                </div>
                            </div>
                            <div *ngIf="offer.type === 'VOUCHER'">{{ offer.discount | localizedNumber }}%</div>
                        </td>
                        <td>
                            {{ offer.start_date | localizedDate : 'shortDate' : 'UTC' }}
                            <span class="table-symbol">→</span>
                            {{ offer.end_date ? (offer.end_date | localizedDate: 'shortDate' : 'UTC') : '∞' }}
                            <div *ngIf="computeRemainingDays(offer)">
                                <small>{{ 'shared.table.remaining' | translate }} {{ computeRemainingDays(offer) || '-'
                                    }} {{ computeRemainingDays(offer) ? ('shared.date.d' | translate) : '' }}</small>
                            </div>
                        </td>
                        <td>
                            {{ (offer.real_end_date | localizedDate: 'shortDate' : 'UTC') || '-' }}
                        </td>
                        <td>
                            {{ (offer.completed_at | localizedDate: 'shortDate' : 'UTC') || '-' }}
                        </td>
                        <td>
                            <app-status-square [status]="offer.status" [small]="true"></app-status-square>
                        </td>
                        <td class="right">
                            <div class="button-rack">
                                <a [routerLink]="[ '/offers/metrics', offer.id ]"
                                    *ngIf="offer.type !== 'LBS_CASHBACK'"><i class="i i-performance"></i></a>
                                <a [routerLink]="getPreviewRouterLink(offer)"><i class="i i-edit"></i></a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <app-pagination (pageChange)="onPageChange($event)"></app-pagination>
    </div>

    <div *ngIf="!offers.length && (filters | hasEmptyValues)">
        <div class="alert-empty alert-empty-offers">
            <img class="icon-big" src="/assets/img/big-offers.svg" alt="Offer icon">
            <h3>{{ 'offers.list.heading' | translate }}</h3>
            <p>{{ 'offers.list.empty' | translate }}</p>
        </div>
    </div>
</div>